import PropTypes from 'prop-types';

export default PropTypes.shape({
  type: PropTypes.string.isRequired,
  maskedValue: PropTypes.string.isRequired,
});
